<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="贷款利率配置">
                <div style="background: #ffffff;position:relative;">
                    <div class="btn-condition">
                        <el-button  @click="handleAdd()" type="primary" v-permission="'operating.calculator.setting'">设置最新贷款利率</el-button>
                    </div>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <el-table-column  label="基准利率" prop="base_rate" ></el-table-column>
                    <el-table-column  label="LPR基础利率" prop="lpr_rate"></el-table-column>
                    <el-table-column  label="公积金贷款利率" prop="fund_rate"></el-table-column>
                    <el-table-column  label="更新日期" prop="created_at"></el-table-column>
                    <el-table-column  label="更新人" prop="operator"></el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
        <add-calputer ref="AddCalputer" :callback="initData"></add-calputer>
    </div>
</template>

<script>
    import { getCalputers } from '@/service/customer'
    import { parseTime } from '@/utils'
    import AddCalputer from './component/add.vue';
    export default {
        name: "List",
        components: {AddCalputer},
        data () {
            return {
                list: [],
                isLoading: false,
                condition:{
                    page:1,
                    per_page:10
                },
                total:0,
            }
        },
        mounted () {
            this.initData()
        },
        methods: {
            handleAdd(){
                this.$refs.AddCalputer &&this.$refs.AddCalputer.open();
            },
            /** 初始化数据请求 */
            async initData () {
                this.list = []
                this.isLoading = true
                // 模拟fetch请求数据....
                await getCalputers(this.condition).then((data) => {
                   this.list = data.data
                   this.total=data.total;
                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            currentChange (index) {
                this.condition.page = index
                this.initData()
            },

        }
    }
</script>

<style scoped>

</style>
